import { useContext, useState, useEffect } from "react";

import { FormControlLabel, Grid, Switch, Zoom } from "@material-ui/core";
import { ExpandLess, ExpandMoreOutlined } from "@material-ui/icons";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";
import useProdutoController from "../controllers/ProdutoController";
import { Margin } from "../../../../theme/styles/Utils";
import Chip from "../../../../components/basics/Chip";
import { HeaderCard, IconButtonStyled } from "../styles/Produto";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import MaskService from "../../../../utils/mask/maskService";

export default function CardProdutoCustoPreco({
  valuesSetters = {},
  accordionMain,
}) {
  // eslint-disable-next-line
  const { errors, setErrors } = useContext(ProdutoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const [openDetailsCost, setOpenDetailsCost] = useState(false);
  const {
    grossCost,
    setGrossCost,
    realCost,
    setRealCost,
    salesMargin,
    setSalesMargin,
    wholeSalesMargin,
    setWholeSalesMargin,
    salePrice,
    setSalePrice,
    taxPrice,
    setTaxPrice,
    freightValue,
    setFreightValue,
    freightPercentage,
    setFreightPercentage,
    insuranceValue,
    setInsuranceValue,
    insurancePercentage,
    setInsurancePercentage,
    discountValue,
    setDiscountValue,
    discountPercentage,
    setDiscountPercentage,
    othersValue,
    setOthersValue,
    othersPercentage,
    setOthersPercentage,
    icmsStValue,
    setIcmsStValue,
    icmsStPercentage,
    setIcmsStPercentage,
    ipiValue,
    setIpiValue,
    ipiPercentage,
    setIpiPercentage,
    pisValue,
    setPisValue,
    pisPercentage,
    setPisPercentage,
    cofinsValue,
    setCofinsValue,
    cofinsPercentage,
    setCofinsPercentage,
    wholesaleValue,
    setWholesaleValue,
    salePriceAux,
    fixedPrice,
    setFixedPrice,
  } = valuesSetters;

  const { removeMaskDecimal, getRealCost } = useProdutoController();

  useEffect(() => {
    reCalcRealCost();
  }, [
    grossCost,
    freightValue,
    insuranceValue,
    discountValue,
    othersValue,
    icmsStValue,
    ipiValue,
    pisValue,
    cofinsValue,
    queryParams,
    cofinsValue,
  ]);

  useEffect(() => {
    setSalePrice(salePriceAux);
    // eslint-disable-next-line
  }, [salePriceAux]);

  useEffect(() => {
    handleSalesNew();
  }, [
    wholeSalesMargin,
    realCost,
    removeMaskDecimal,
    setSalePrice,
    setWholesaleValue,
  ]);

  const handleSalesNew = () => {
    let newValue,
      newValueWholeSale,
      margemVenda = removeMaskDecimal(salesMargin, 5),
      margemAtacado = removeMaskDecimal(
        MaskService.toMask("decimal", wholeSalesMargin, 2)
      ),
      custoReal = removeMaskDecimal(MaskService.toMask("decimal", realCost, 5));

    newValue = (margemVenda / 100) * custoReal + custoReal;
    newValueWholeSale = (margemAtacado / 100) * custoReal + custoReal;

    setSalePrice(MaskService.toMask("decimal", newValue.toFixed(2), 2));
    setWholesaleValue(
      MaskService.toMask("decimal", newValueWholeSale.toFixed(2), 2)
    );
  };

  useEffect(() => {
    if (queryParams?.datanf) {
      let dataNF = Buffer.from(queryParams.datanf, "base64").toString();
      dataNF = JSON.parse(dataNF);
      let tempGrossCost = (
        !isNaN(parseFloat(dataNF["custobruto"]))
          ? parseFloat(dataNF["custobruto"])
          : 0
      ).toFixed(5);

      setGrossCost(MaskService.toMask("decimal", tempGrossCost, 5));
    }
  }, [queryParams, setGrossCost]);

  const handleSalesMargin = () => {
    let novaMargemVenda,
      novaMargemAtacado,
      custoReal = removeMaskDecimal(realCost, 5),
      precoVenda = removeMaskDecimal(salePrice),
      precoAtacado = removeMaskDecimal(wholesaleValue);

    if (precoVenda === 0) {
      setSalesMargin(MaskService.toMask("decimal", "0.00000", 5));
      return;
    }

    if (precoAtacado === 0) {
      setWholeSalesMargin(MaskService.toMask("decimal", "0.00", 2));
      return;
    }

    novaMargemVenda = ((precoVenda - custoReal) / custoReal) * 100;
    novaMargemAtacado = ((precoAtacado - custoReal) / custoReal) * 100;

    setSalesMargin(
      MaskService.toMask("decimal", novaMargemVenda.toFixed(5), 5)
    );
    setWholeSalesMargin(
      MaskService.toMask("decimal", novaMargemAtacado.toFixed(2), 2)
    );
  };

  const handleCostPercentage = (setDestiny, valor, percentageCost, setThis) => {
    let newValor,
      newGrossCost = removeMaskDecimal(grossCost, 5);

    if (percentageCost) {
      //Percentage to cost
      newValor =
        (removeMaskDecimal(MaskService.toMask("decimal", valor, 5)) *
          newGrossCost) /
        100;
    } else {
      //Cost to percentage
      newValor =
        (removeMaskDecimal(MaskService.toMask("decimal", valor, 5)) * 100) /
        newGrossCost;
    }

    setThis(MaskService.toMask("decimal", valor, 5));
    setDestiny(MaskService.toMask("decimal", newValor.toFixed(5), 5));
    reCalcRealCost();
  };

  const reCalcRealCost = () => {
    setRealCost(
      getRealCost({
        custoBrutoEstoque: removeMaskDecimal(grossCost, 5),
        freteEstoque: removeMaskDecimal(freightValue, 5),
        seguroEstoque: removeMaskDecimal(insuranceValue, 5),
        outrasDespEstoque: removeMaskDecimal(othersValue, 5),
        icmsstEstoque: removeMaskDecimal(icmsStValue, 5),
        ipiEstoque: removeMaskDecimal(ipiValue, 5),
        descontoEstoque: removeMaskDecimal(discountValue, 5),
        cofinsEstoque: removeMaskDecimal(cofinsValue, 5),
        pisEstoque: removeMaskDecimal(pisValue, 5),
      })
    );
  };

  return (
    <Grid item xs={12}>
      <Card line="left" lineColor="primary">
        <HeaderCard>
          <Grid container>
            <Chip label="CUSTOS E PREÇOS" bgcolor="secondary" />
          </Grid>
        </HeaderCard>

        <Margin top="10">
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errors.grossCost ? true : false}
                helperText={errors.grossCost || ""}
                label="Custo Bruto"
                maxLength={120}
                mask="decimal"
                decimals={5}
                value={grossCost}
                setValue={setGrossCost}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errors.realCost ? true : false}
                helperText={errors.realCost || ""}
                label="Custo Real"
                disabled
                maxLength={120}
                mask="decimal"
                decimals={5}
                value={realCost}
                setValue={setRealCost}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errors.salesMargin ? true : false}
                helperText={errors.salesMargin || ""}
                label="Margem de Venda (%)"
                maxLength={120}
                mask="decimal"
                decimals={5}
                value={salesMargin}
                setValue={setSalesMargin}
                onBlur={() => handleSalesNew()}
              />
            </Grid>

            {/* ACCORDION PRINCIPAL */}
            {accordionMain && (
              <>
                {queryParams.paramutilizatabelaprecos === "NAO" &&
                  queryParams.paramutilizavarejoatacado === "SIM" && (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <TextFieldErp
                        error={errors.salesMargin ? true : false}
                        helperText={errors.salesMargin || ""}
                        label="Preço Atacado"
                        maxLength={120}
                        mask="decimal"
                        decimals={2}
                        value={wholesaleValue}
                        setValue={setWholesaleValue}
                      />
                    </Grid>
                  )}
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextFieldErp
                    error={errors.salePrice ? true : false}
                    helperText={errors.salePrice || ""}
                    label={`Preço ${
                      queryParams.paramutilizavarejoatacado === "SIM" &&
                      queryParams.paramutilizatabelaprecos === "NAO"
                        ? "Varejo"
                        : "de Venda"
                    }`}
                    maxLength={120}
                    mask="decimal"
                    decimals={2}
                    value={salePrice}
                    setValue={setSalePrice}
                    onBlur={() => handleSalesMargin()}
                  />
                </Grid>

                {queryParams.paramutilizatabelaprecos === "SIM" &&
                  queryParams.permiteprecofixo === "SIM" && (
                    <>
                      <Grid item flex={1} style={{ marginLeft: "auto" }}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={fixedPrice}
                              onChange={() =>
                                setFixedPrice((current) => !current)
                              }
                              color="primary"
                            />
                          }
                          label="Preço fixo"
                          labelPlacement="end"
                        />
                      </Grid>

                      {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextFieldErp
                          error={errors.salePrice ? true : false}
                          helperText={errors.salePrice || ""}
                          label="Percentual Fixo"
                          maxLength={120}
                          mask="decimal"
                          value={salePrice}
                          setValue={setSalePrice}
                        />
                      </Grid> */}
                    </>
                  )}

                {queryParams.paramprecoestoqueunico === "SIM" && (
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <TextFieldErp
                      error={!!errors.taxPrice}
                      helperText={errors.taxPrice || ""}
                      label="Preço Tributável"
                      maxLength={120}
                      mask="decimal"
                      decimals={2}
                      value={taxPrice}
                      setValue={setTaxPrice}
                    />
                  </Grid>
                )}
              </>
            )}

            {/* MODAL LOCAIS DE ESTOQUE */}
            {!accordionMain && queryParams.paramprecoestoqueunico === "NAO" && (
              <>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextFieldErp
                    error={errors.salePrice ? true : false}
                    helperText={errors.salePrice || ""}
                    label={`Preço ${
                      queryParams.paramutilizavarejoatacado === "SIM" &&
                      queryParams.paramutilizatabelaprecos === "NAO"
                        ? "Varejo"
                        : "de Venda"
                    }`}
                    maxLength={120}
                    mask="decimal"
                    decimals={2}
                    value={salePrice}
                    setValue={setSalePrice}
                    onBlur={() => handleSalesMargin()}
                  />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <TextFieldErp
                    error={!!errors.taxPrice}
                    helperText={errors.taxPrice || ""}
                    label="Preço Tributável"
                    maxLength={120}
                    mask="decimal"
                    decimals={2}
                    value={taxPrice}
                    setValue={setTaxPrice}
                  />
                </Grid>

                {queryParams.paramutilizatabelaprecos === "SIM" &&
                  queryParams.permiteprecofixo === "SIM" && (
                    <Grid item flex={1} style={{ marginLeft: "auto" }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={fixedPrice}
                            onChange={() =>
                              setFixedPrice((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Preço fixo"
                        labelPlacement="end"
                      />
                    </Grid>
                  )}

                {queryParams.paramutilizatabelaprecos === "NAO" &&
                  queryParams.paramutilizavarejoatacado === "SIM" && (
                    <>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextFieldErp
                          error={errors.salesMargin ? true : false}
                          helperText={errors.salesMargin || ""}
                          label="Margem de Atacado (%)"
                          maxLength={120}
                          mask="decimal"
                          decimals={2}
                          value={wholeSalesMargin}
                          setValue={setWholeSalesMargin}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextFieldErp
                          error={errors.salesMargin ? true : false}
                          helperText={errors.salesMargin || ""}
                          label="Preço Atacado"
                          maxLength={120}
                          mask="decimal"
                          decimals={2}
                          value={wholesaleValue}
                          setValue={setWholesaleValue}
                          onBlur={() => handleSalesMargin()}
                        />
                      </Grid>
                    </>
                  )}
              </>
            )}

            <Grid
              item
              xs={12}
              container
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <IconButtonStyled
                onClick={() => setOpenDetailsCost((current) => !current)}
              >
                {openDetailsCost ? <ExpandLess /> : <ExpandMoreOutlined />}
              </IconButtonStyled>
            </Grid>

            {openDetailsCost && (
              <Zoom in={true}>
                <Grid item xs>
                  <Card>
                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.freightValue ? true : false}
                          helperText={errors.freightValue || ""}
                          label="Frete(+)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={freightValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setFreightPercentage,
                              e.target.value,
                              false,
                              setFreightValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.freightPercentage ? true : false}
                          helperText={errors.freightPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={freightPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setFreightValue,
                              e.target.value,
                              true,
                              setFreightPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.insuranceValue ? true : false}
                          helperText={errors.insuranceValue || ""}
                          label="Seguro(+)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={insuranceValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setInsurancePercentage,
                              e.target.value,
                              false,
                              setInsuranceValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.insurancePercentage ? true : false}
                          helperText={errors.insurancePercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={insurancePercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setInsuranceValue,
                              e.target.value,
                              true,
                              setInsurancePercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.discountValue ? true : false}
                          helperText={errors.discountValue || ""}
                          label="Desconto(-)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={discountValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setDiscountPercentage,
                              e.target.value,
                              false,
                              setDiscountValue
                            )
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.discountPercentage ? true : false}
                          helperText={errors.discountPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={discountPercentage}
                          setValue={setDiscountPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setDiscountValue,
                              e.target.value,
                              true,
                              setDiscountPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.othersValue ? true : false}
                          helperText={errors.othersValue || ""}
                          label="Outras Despesas(+)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={othersValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setOthersPercentage,
                              e.target.value,
                              false,
                              setOthersValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.othersPercentage ? true : false}
                          helperText={errors.othersPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={othersPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setOthersValue,
                              e.target.value,
                              true,
                              setOthersPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.icmsStValue ? true : false}
                          helperText={errors.icmsStValue || ""}
                          label="ICMS ST(+)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={icmsStValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setIcmsStPercentage,
                              e.target.value,
                              false,
                              setIcmsStValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.icmsStPercentage ? true : false}
                          helperText={errors.icmsStPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={icmsStPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setIcmsStValue,
                              e.target.value,
                              true,
                              setIcmsStPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.ipiValue ? true : false}
                          helperText={errors.ipiValue || ""}
                          label="IPI(+)"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={ipiValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setIpiPercentage,
                              e.target.value,
                              false,
                              setIpiValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.ipiPercentage ? true : false}
                          helperText={errors.ipiPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={ipiPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setIpiValue,
                              e.target.value,
                              true,
                              setIpiPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.pisValue ? true : false}
                          helperText={errors.pisValue || ""}
                          label={
                            "PIS" +
                            `${queryParams.crt === "3" ? "(+)" : "(=)"} `
                          }
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={pisValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setPisPercentage,
                              e.target.value,
                              false,
                              setPisValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.pisPercentage ? true : false}
                          helperText={errors.pisPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={pisPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setPisValue,
                              e.target.value,
                              true,
                              setPisPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.cofinsValue ? true : false}
                          helperText={errors.cofinsValue || ""}
                          label={
                            "COFINS" +
                            `${queryParams.crt === "3" ? "(+)" : "(=)"} `
                          }
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={cofinsValue}
                          onChange={(e) =>
                            handleCostPercentage(
                              setCofinsPercentage,
                              e.target.value,
                              false,
                              setCofinsValue
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextFieldErp
                          error={errors.cofinsPercentage ? true : false}
                          helperText={errors.cofinsPercentage || ""}
                          label="%"
                          maxLength={120}
                          mask="decimal"
                          decimals={5}
                          value={cofinsPercentage}
                          onChange={(e) =>
                            handleCostPercentage(
                              setCofinsValue,
                              e.target.value,
                              true,
                              setCofinsPercentage
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Zoom>
            )}
          </Grid>
        </Margin>
      </Card>
    </Grid>
  );
}
